const button = {
  baseStyle: {
    borderRadius: "100px",
    fontWeight: 700,
    display: "flex",
    fontFamily: "Juneau",
    alignItems: "center",
    fontSize: "1rem",
    gap: "8px",
    lineHeight: "100%",
    letterSpacing: "0px",
    paddingLeft: "2rem",
    paddingRight: "2rem",
  },
  variants: {
    solid: variantSolid,
  },
};

export default button;

function variantSolid(props) {
  const { colorScheme: c } = props;

  let color = undefined;
  let bgColor = undefined;
  let hoverColor = undefined;
  let bgHoverColor = undefined;
  let border = undefined;
  let boxShadow = undefined;

  // Special color schemes
  if (c === "blue") {
    color = "white";
    bgColor = "blue.650";
    hoverColor = "white";
    bgHoverColor = "gray.333";
    border = "none";
    boxShadow = "0 0 0 3px rgba(0, 0, 0, 0.25)";
  }

  if (c === "white") {
    border = "1px solid #333";
    color = "gray.333";
    bgHoverColor = "gray.333";
    hoverColor = "white";
    boxShadow = "none";
  }

  if (c === "red") {
    border = "none";
    color = "white";
    bgHoverColor = "gray.333";
    hoverColor = "white";
    boxShadow = "none";
  }

  return {
    //fontFamily: "Juneau",
    display: "flex",
    alignItems: "center",
    fontSize: "1rem",
    gap: "8px",
    lineHeight: "100%",
    letterSpacing: "0px",
    paddingLeft: "2rem",
    paddingRight: "2rem",
    fontWeight: 400,
    color,
    bg: bgColor,
    border: border,
    _hover: {
      color: hoverColor,
      bg: bgHoverColor,
    },
    _active: {
      color: hoverColor,
      bg: bgHoverColor,
    },
    _focus: {
      boxShadow: boxShadow,
    },
  };
}
